import script from "./CustomBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomBadge.vue?vue&type=script&setup=true&lang=ts"

import "./CustomBadge.vue?vue&type=style&index=0&id=27d3067f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d3067f"]])

export default __exports__